import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgBook(props: RootSvgProps) {
  return (
    <RootSvg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.5"
        y="8.5"
        width="47"
        height="47"
        rx="7.5"
        fill="#7ABBDF"
        stroke="black"
        strokeWidth="3"
      />
      <rect
        x="15.5"
        y="33.5"
        width="7"
        height="15"
        rx="1.5"
        fill="#FFF4D9"
        stroke="black"
        strokeWidth="3"
      />
      <rect
        x="28.5"
        y="26.5"
        width="7"
        height="22"
        rx="1.5"
        fill="#FFF4D9"
        stroke="black"
        strokeWidth="3"
      />
      <rect
        x="41.5"
        y="19.5"
        width="7"
        height="29"
        rx="1.5"
        fill="#FFF4D9"
        stroke="black"
        strokeWidth="3"
      />
    </RootSvg>
  );
}
